import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Sat Sep 09 2018
 * @author LZe
 */
import moment from 'moment';
import * as React from 'react';
import { DatePickerValidated } from '../../../../inputs/DatePicker';
import CellEditor from './CellEditor';
import { OptionalDesc, PropDesc } from '@logio/common-be-fe';
/**
 * Date editor for the AgGrid
 * @extends CellEditor
 */

var DateEditor =
/*#__PURE__*/
function (_CellEditor) {
  _inherits(DateEditor, _CellEditor);

  function DateEditor(props) {
    var _this;

    _classCallCheck(this, DateEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateEditor).call(this, props)); // parser = this.colDef.schema.parser as DateParser;

    _this.parser = DateEditor.getParser(_this.colDef.schema);
    /**
     * Handles changes in the input element of the date picker
     */

    _this.onChange = function (date) {
      if (date.isSameOrBefore(moment(new Date(2049, 12)))) {
        _this.updateValue(date);
      }
    };

    _this.isPopup = function () {
      return true;
    };

    _this.render = function () {
      return React.createElement("div", {
        ref: _this.wrapper
      }, React.createElement(DatePickerValidated, {
        value: _this.state.value,
        onChange: _this.onChange
      }));
    };

    return _this;
  }

  _createClass(DateEditor, null, [{
    key: "getParser",
    value: function getParser(schema) {
      if (schema instanceof PropDesc) {
        return schema.parser;
      }

      if (schema instanceof OptionalDesc) {
        return DateEditor.getParser(schema.base);
      }

      throw new Error('Can not determine parser');
    }
  }]);

  return DateEditor;
}(CellEditor);

export { DateEditor as default };